module.exports = __webpack_public_path__ + "static/media/shiv_2ccRHKSu8B.5bef5b92.jpeg";